// 适配ie(转换es6 语法)
import '@babel/polyfill'

import Vue from 'vue'
import App from './App'
import router from './router'
Vue.config.productionTip = false
// import http from './config/httpConfig'
// Vue.prototype.$http = http
//引入 vuex
import store from './store/index';


//引入 第三方动画库
// import 'animate.css'

//引入 第三方字体
import '@/assets/font/font.css'

//引入 基本样式
import '@/common/css/reset.css'

//引入 公用样式
import '@/common/css/common.less'


import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

Vue.use(VueAwesomeSwiper)

//引入 Element
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(Element)

// 路由发生变化修改页面title 
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
   document.title = to.meta.title
  }
  next()
})

 
import axios from 'axios'
//然后进行全局注册  (这里的$axios是自己的取的名字 应该是约定俗成写成这样)
Vue.prototype.$axios = axios

// new Vue({
//   el: '#app',
//   router,
//   store,
//   components: { App },
//   template: '<App/>'
// })
export default new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

 




// WEBPACK FOOTER //
// ./src/main.js